import React, { useState, useRef, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import AdminCustomButton from '../AdminCustomButton';

// --- Placeholder Icons (Replace with your actual SVGs or library icons) ---
const AddIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path d="M8 1a.5.5 0 0 1 .5.5v6h6a.5.5 0 0 1 0 1h-6v6a.5.5 0 0 1-1 0v-6H1a.5.5 0 0 1 0-1h6V1.5A.5.5 0 0 1 8 1z" />
    </svg>
);
const RemoveIcon = () => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
);
const GenericFileIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9.172 16.172a4 4 0 015.656 0l1.06 1.061a1 1 0 01-1.414 1.414l-1.06-1.06a2 2 0 10-2.828-2.829l-3.183 3.182a2 2 0 00-.586 1.414V20a1 1 0 11-2 0v-.757a4 4 0 011.172-2.829l3.182-3.182zM10 6a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM4 6a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zM4 9a1 1 0 011-1h7a1 1 0 110 2H5a1 1 0 01-1-1z" />
        <path
            fillRule="evenodd"
            d="M5 2a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V8.828a3 3 0 00-.879-2.121l-4-4A3 3 0 0013.172 2H5zm9.172 2l4 4H15a1 1 0 01-1-1V4h-.828zM4 5a1 1 0 011-1h7v4a3 3 0 003 3h4v9a1 1 0 01-1 1H5a1 1 0 01-1-1V5z"
            clipRule="evenodd"
        />
    </svg>
);
const PdfFileIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.0759 1.55469L22.2489 5.90469V22.4467H6.66016V22.5007H22.3022V5.95944L18.0759 1.55469Z"
            fill="#909090"
        />
        <path
            d="M18.0227 1.5H6.60547V22.446H22.2475V5.90475L18.0227 1.5Z"
            fill="#F4F4F4"
        />
        <path
            d="M6.49172 2.625H1.69922V7.74525H16.7742V2.625H6.49172Z"
            fill="#7A7B7C"
        />
        <path
            d="M16.8546 7.65525H1.79688V2.53125H16.8546V7.65525Z"
            fill="#DD2025"
        />
        <path
            d="M6.78884 3.40197H5.80859V7.00197H6.57959V5.78772L6.74984 5.79747C6.91533 5.79519 7.07929 5.76553 7.23509 5.70972C7.37206 5.66321 7.49794 5.58891 7.60484 5.49147C7.71447 5.39955 7.8006 5.28282 7.85609 5.15097C7.93203 4.9325 7.95891 4.69999 7.93484 4.46997C7.93057 4.3056 7.90175 4.14281 7.84934 3.98697C7.80212 3.87432 7.7319 3.77278 7.64317 3.68883C7.55445 3.60489 7.44918 3.54039 7.33409 3.49947C7.23488 3.46272 7.13206 3.43657 7.02734 3.42147C6.94824 3.40858 6.86824 3.40206 6.78809 3.40197M6.64634 5.12247H6.57959V4.01247H6.72434C6.78823 4.00786 6.85233 4.01767 6.91192 4.04116C6.9715 4.06466 7.02505 4.10124 7.06859 4.14822C7.15883 4.26898 7.20704 4.41597 7.20584 4.56672C7.20584 4.75122 7.20584 4.91847 7.03934 5.03622C6.91942 5.10227 6.78287 5.13273 6.64634 5.12247ZM9.39959 3.39222C9.31634 3.39222 9.23534 3.39822 9.17834 3.40047L8.99984 3.40497H8.41484V7.00497H9.10334C9.36643 7.01173 9.62831 6.96715 9.87434 6.87372C10.0724 6.79549 10.2478 6.66888 10.3843 6.50547C10.5182 6.34133 10.6137 6.14943 10.6641 5.94372C10.7232 5.71116 10.752 5.47191 10.7496 5.23197C10.7643 4.94858 10.7423 4.66449 10.6843 4.38672C10.6288 4.18248 10.5261 3.99417 10.3843 3.83697C10.2732 3.70985 10.1365 3.60762 9.98309 3.53697C9.85171 3.47607 9.71346 3.43124 9.57134 3.40347C9.51483 3.3942 9.45761 3.38994 9.40034 3.39072M9.26384 6.34347H9.18884V4.04547H9.19859C9.35322 4.02759 9.50968 4.05549 9.64859 4.12572C9.75034 4.20696 9.83325 4.30932 9.89159 4.42572C9.95456 4.54822 9.99086 4.68267 9.99809 4.82022C10.0048 4.98522 9.99809 5.12022 9.99809 5.23197C10.0009 5.36069 9.99259 5.48941 9.97334 5.61672C9.94975 5.74726 9.90704 5.87362 9.84659 5.99172C9.77831 6.10185 9.68504 6.19435 9.57434 6.26172C9.48188 6.32172 9.37225 6.34965 9.26234 6.34122M13.0723 3.40497H11.2498V7.00497H12.0208V5.57697H12.9958V4.90797H12.0208V4.07397H13.0708V3.40497"
            fill="#464648"
        />
        <path
            d="M16.3365 15.1882C16.3365 15.1882 18.7275 14.7547 18.7275 15.5715C18.7275 16.3882 17.2462 16.056 16.3365 15.1882ZM14.5687 15.2505C14.1888 15.3342 13.8186 15.4571 13.464 15.6172L13.764 14.9422C14.064 14.2672 14.3752 13.347 14.3752 13.347C14.7323 13.95 15.1489 14.5159 15.6187 15.036C15.265 15.0886 14.9145 15.1608 14.5687 15.252V15.2505ZM13.6222 10.3755C13.6222 9.66371 13.8525 9.46946 14.0317 9.46946C14.211 9.46946 14.4127 9.55571 14.4195 10.1737C14.361 10.7951 14.2309 11.4077 14.0317 11.9992C13.758 11.5029 13.6167 10.9445 13.6215 10.3777L13.6222 10.3755ZM10.1355 18.2625C9.40199 17.8237 11.6737 16.473 12.0855 16.4295C12.0832 16.4302 10.9035 18.7215 10.1355 18.2625ZM19.4257 15.6682C19.4182 15.5932 19.3507 14.763 17.8732 14.7982C17.2574 14.7874 16.6418 14.8308 16.0335 14.928C15.4439 14.3345 14.9364 13.6648 14.5245 12.9367C14.7838 12.1862 14.941 11.4042 14.9917 10.6117C14.97 9.71171 14.7547 9.19571 14.0647 9.20321C13.3747 9.21071 13.2742 9.81446 13.365 10.713C13.4538 11.3168 13.6215 11.9063 13.8637 12.4665C13.8637 12.4665 13.545 13.4587 13.1235 14.4457C12.702 15.4327 12.414 15.9502 12.414 15.9502C11.6809 16.1885 10.9909 16.5431 10.3702 17.0002C9.75225 17.5755 9.501 18.0172 9.8265 18.459C10.107 18.84 11.0887 18.9262 11.9662 17.7765C12.4317 17.182 12.8576 16.5577 13.2412 15.9075C13.2412 15.9075 14.5792 15.5407 14.9955 15.4402C15.4117 15.3397 15.915 15.2602 15.915 15.2602C15.915 15.2602 17.1367 16.4895 18.315 16.446C19.4932 16.4025 19.4362 15.7417 19.4287 15.6697"
            fill="#DD2025"
        />
        <path
            d="M17.9648 1.55469V5.95944H22.1896L17.9648 1.55469Z"
            fill="#909090"
        />
        <path d="M18.0234 1.5V5.90475H22.2482L18.0234 1.5Z" fill="#F4F4F4" />
        <path
            d="M6.73025 3.33947H5.75V6.93947H6.524V5.72597L6.695 5.73572C6.86048 5.73344 7.02445 5.70378 7.18025 5.64797C7.31722 5.60146 7.4431 5.52716 7.55 5.42972C7.6588 5.33754 7.74415 5.22084 7.799 5.08922C7.87493 4.87075 7.90182 4.63824 7.87775 4.40822C7.87347 4.24385 7.84466 4.08106 7.79225 3.92522C7.74502 3.81257 7.6748 3.71103 7.58608 3.62708C7.49735 3.54314 7.39208 3.47864 7.277 3.43772C7.17733 3.40061 7.074 3.37421 6.96875 3.35897C6.88965 3.34608 6.80964 3.33956 6.7295 3.33947M6.58775 5.05997H6.521V3.94997H6.6665C6.73039 3.94536 6.79449 3.95517 6.85407 3.97866C6.91366 4.00216 6.9672 4.03874 7.01075 4.08572C7.10099 4.20648 7.1492 4.35347 7.148 4.50422C7.148 4.68872 7.148 4.85597 6.9815 4.97372C6.86158 5.03977 6.72502 5.06948 6.5885 5.05922M9.341 3.32972C9.25775 3.32972 9.17675 3.33572 9.11975 3.33797L8.9435 3.34247H8.3585V6.94247H9.047C9.31009 6.94923 9.57197 6.90465 9.818 6.81122C10.0161 6.73299 10.1914 6.60638 10.328 6.44297C10.4618 6.27883 10.5574 6.08693 10.6078 5.88122C10.6669 5.64866 10.6956 5.40941 10.6932 5.16947C10.7079 4.88608 10.686 4.60199 10.628 4.32422C10.5725 4.11998 10.4697 3.93167 10.328 3.77447C10.2168 3.64735 10.0801 3.54512 9.92675 3.47447C9.79537 3.41357 9.65712 3.36874 9.515 3.34097C9.45848 3.3317 9.40126 3.32744 9.344 3.32822M9.2075 6.28097H9.1325V3.98297H9.14225C9.29687 3.96509 9.45334 3.99299 9.59225 4.06322C9.694 4.14446 9.7769 4.24682 9.83525 4.36322C9.89822 4.48572 9.93451 4.62017 9.94175 4.75772C9.9485 4.92272 9.94175 5.05772 9.94175 5.16947C9.94452 5.29819 9.93624 5.42691 9.917 5.55422C9.8934 5.68476 9.8507 5.81112 9.79025 5.92922C9.72196 6.03935 9.6287 6.13185 9.518 6.19922C9.42553 6.25922 9.3159 6.28715 9.206 6.27872M13.0138 3.34247H11.1913V6.94247H11.9622V5.51447H12.9372V4.84547H11.9622V4.01147H13.0122V3.34247"
            fill="white"
        />
    </svg>
);

const DocFileIcon = () => (
    <svg
        width="26"
        height="36"
        viewBox="0 0 26 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.8674 0L16.7143 9L25.7143 12.8571L25.6937 32.1429C25.6937 33.1658 25.2873 34.1469 24.564 34.8703C23.8406 35.5936 22.8595 36 21.8366 36H3.85714C2.83416 36 1.85309 35.5936 1.12973 34.8703C0.406377 34.1469 0 33.1658 0 32.1429V3.85714C0 2.83416 0.406377 1.85309 1.12973 1.12973C1.85309 0.406377 2.83416 0 3.85714 0H12.8674Z"
            fill="url(#paint0_linear_4181_22357)"
        />
        <path
            d="M12.8674 0L16.7143 9L25.7143 12.8571L25.6937 32.1429C25.6937 33.1658 25.2873 34.1469 24.564 34.8703C23.8406 35.5936 22.8595 36 21.8366 36H3.85714C2.83416 36 1.85309 35.5936 1.12973 34.8703C0.406377 34.1469 0 33.1658 0 32.1429V3.85714C0 2.83416 0.406377 1.85309 1.12973 1.12973C1.85309 0.406377 2.83416 0 3.85714 0H12.8674Z"
            fill="url(#paint1_radial_4181_22357)"
            fill-opacity="0.5"
        />
        <path
            d="M12.8594 9V0L25.7165 12.8571H16.7165C15.6935 12.8571 14.7125 12.4508 13.9891 11.7274C13.2658 11.0041 12.8594 10.023 12.8594 9Z"
            fill="url(#paint2_linear_4181_22357)"
        />
        <path
            d="M6.42634 18C6.08535 18 5.75832 18.1355 5.5172 18.3766C5.27608 18.6177 5.14062 18.9447 5.14062 19.2857C5.14062 19.6267 5.27608 19.9537 5.5172 20.1949C5.75832 20.436 6.08535 20.5714 6.42634 20.5714H19.2835C19.6245 20.5714 19.9515 20.436 20.1926 20.1949C20.4337 19.9537 20.5692 19.6267 20.5692 19.2857C20.5692 18.9447 20.4337 18.6177 20.1926 18.3766C19.9515 18.1355 19.6245 18 19.2835 18H6.42634ZM5.14062 24.4286C5.14062 24.0876 5.27608 23.7606 5.5172 23.5194C5.75832 23.2783 6.08535 23.1429 6.42634 23.1429H19.2835C19.6245 23.1429 19.9515 23.2783 20.1926 23.5194C20.4337 23.7606 20.5692 24.0876 20.5692 24.4286C20.5692 24.7696 20.4337 25.0966 20.1926 25.3377C19.9515 25.5788 19.6245 25.7143 19.2835 25.7143H6.42634C6.08535 25.7143 5.75832 25.5788 5.5172 25.3377C5.27608 25.0966 5.14062 24.7696 5.14062 24.4286ZM6.42634 28.2857C6.08535 28.2857 5.75832 28.4212 5.5172 28.6623C5.27608 28.9034 5.14062 29.2304 5.14062 29.5714C5.14062 29.9124 5.27608 30.2394 5.5172 30.4806C5.75832 30.7217 6.08535 30.8571 6.42634 30.8571H19.2835C19.6245 30.8571 19.9515 30.7217 20.1926 30.4806C20.4337 30.2394 20.5692 29.9124 20.5692 29.5714C20.5692 29.2304 20.4337 28.9034 20.1926 28.6623C19.9515 28.4212 19.6245 28.2857 19.2835 28.2857H6.42634Z"
            fill="url(#paint3_linear_4181_22357)"
            fill-opacity="0.9"
        />
        <defs>
            <linearGradient
                id="paint0_linear_4181_22357"
                x1="17.9846"
                y1="1.11639e-07"
                x2="21.2503"
                y2="30.294"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#6CE0FF" />
                <stop offset="1" stop-color="#4894FE" />
            </linearGradient>
            <radialGradient
                id="paint1_radial_4181_22357"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(26.764 1.12259) rotate(130.372) scale(21.4849 12.5346)"
            >
                <stop offset="0.362" stop-color="#4A43CB" />
                <stop offset="1" stop-color="#4A43CB" stop-opacity="0" />
            </radialGradient>
            <linearGradient
                id="paint2_linear_4181_22357"
                x1="19.2674"
                y1="5.35629"
                x2="16.0531"
                y2="10.7151"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#9FF0F9" />
                <stop offset="1" stop-color="#B3E0FF" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_4181_22357"
                x1="20.5692"
                y1="36"
                x2="6.56263"
                y2="12.0266"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#9DEAFF" />
                <stop offset="1" stop-color="white" />
            </linearGradient>
        </defs>
    </svg>
);
// --- End Placeholder Icons ---

export interface FileData {
    id?: string | number; // Optional ID for existing files from backend
    file?: File; // Local file object when uploading
    blob?: Blob; // Blob data
    url?: string; // URL string from backend
    previewUrl?: string; // Local preview URL for display
    name: string; // File name
    size: number; // File size in bytes
    type: string; // File mimetype
    uniqueId: string;
} // Assuming this component exists

interface MultipleProps {
    className?: string;
    selectedFiles: FileData[];
    setSelectedFiles: React.Dispatch<React.SetStateAction<FileData[]>>;
    bgColor?: string;
    borderColor?: string;
    accept?: string; // e.g., "image/*,.pdf,.docx"
    maxFiles?: number;
    maxFileSizeMB?: number; // Max size per file in MB
    // Add button props (optional, could be just an icon)
    addButtonLabel?: string;
    addButtonType?:
    | 'primary'
    | 'secondary'
    | 'icon'
    | 'edit'
    | 'card'
    | 'nav-icon'
    | 'delete'
    | 'cancel'
    | 'save'
    | 'uploadFile';
    addIcon?: React.ReactNode;
    // Overall action button (e.g., "Upload All")
    actionButtonLabel?: string;
    actionButtonType?:
    | 'primary'
    | 'secondary'
    | 'icon'
    | 'edit'
    | 'card'
    | 'nav-icon'
    | 'delete'
    | 'cancel'
    | 'save'
    | 'uploadFile';
    actionButtonSvgIcon?: React.ReactNode;
    onActionButtonClick?: (files: Blob[]) => void; // Now passes Blob objects
    isLoader?: boolean;
    onError?: (message: string) => void; // Callback for errors

    // New props for handling existing images
    existingUrls?: string[]; // Array of image URLs from backend
    showStar?: boolean;
    label?: string;
    onRemoveFile?: (index: number) => void;
}

export const generateUniqueId = (): string => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export const MultipleFileUploadCard = ({
    className,
    selectedFiles,
    setSelectedFiles,
    bgColor,
    borderColor,
    accept = 'image/*', // Default to images
    maxFiles,
    maxFileSizeMB,
    addButtonLabel = 'Add File',
    addButtonType = 'secondary',
    addIcon = <AddIcon />,
    actionButtonLabel,
    actionButtonType = 'primary',
    actionButtonSvgIcon,
    onActionButtonClick,
    isLoader,
    onError,
    existingUrls = [],
    showStar,
    label,
    onRemoveFile,
}: MultipleProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    // Used to track processed URLs and avoid duplicates
    const [processedUrls, setProcessedUrls] = useState<Set<string>>(new Set());

    // Process existing URLs on mount or when they change
    useEffect(() => {
        const loadExistingFiles = async () => {
            if (!existingUrls?.length) return;

            // Only process URLs we haven't seen yet
            const newUrls = existingUrls.filter(url => !processedUrls.has(url));
            if (newUrls.length === 0) return;

            // Create file data objects for each URL
            const newFileData: FileData[] = [];

            for (const url of newUrls) {
                try {
                    // Extract filename from URL
                    const fileName = url.split('/').pop() || 'file';

                    // Create a preview
                    const fileData: FileData = {
                        url,
                        previewUrl: url,
                        name: fileName,
                        size: 0, // We don't know size from URL
                        type: url.toLowerCase().endsWith('.pdf')
                            ? 'application/pdf'
                            : 'image/*',
                        uniqueId: generateUniqueId(), // Generate unique ID for React key
                    };

                    // Try to get the file size and better type info
                    try {
                        const response = await fetch(url, { method: 'HEAD' });
                        const contentLength = response.headers.get('content-length');
                        const contentType = response.headers.get('content-type');

                        if (contentLength) {
                            fileData.size = parseInt(contentLength, 10);
                        }

                        if (contentType) {
                            fileData.type = contentType;
                        }
                    } catch (error) {
                        console.warn('Could not fetch file metadata:', error);
                    }

                    newFileData.push(fileData);
                } catch (error) {
                    console.error(`Error processing URL ${url}:`, error);
                }
            }

            // Add new file data to selected files
            if (newFileData.length > 0) {
                setSelectedFiles(prev => [...prev, ...newFileData]);

                // Mark these URLs as processed
                setProcessedUrls(prev => {
                    const newSet = new Set(prev);
                    newUrls.forEach(url => newSet.add(url));
                    return newSet;
                });
            }
        };

        loadExistingFiles();
    }, [existingUrls, setSelectedFiles, processedUrls]);

    // Create and revoke object URLs for previews
    useEffect(() => {
        // Nothing to cleanup on unmount - we'll handle preview cleanup in the removeFile function
        return () => {
            selectedFiles.forEach(fileData => {
                if (fileData.previewUrl && !fileData.url) {
                    // Only revoke URLs we created, not original URLs from backend
                    URL.revokeObjectURL(fileData.previewUrl);
                }
            });
        };
    }, []);

    // Function to check if a file type is accepted
    const isFileTypeAccepted = useCallback(
        (file: File): boolean => {
            if (!accept || accept === '*/*') return true;

            // Parse accept string into array of MIME types and extensions
            const acceptedTypes = accept
                .split(',')
                .map(type => type.trim().toLowerCase());

            // Get file MIME type and extension
            const fileType = file.type.toLowerCase();
            const fileExtension = `.${file.name.split('.').pop()?.toLowerCase() || ''
                }`;

            // Check if file type matches any accepted types
            return acceptedTypes.some(acceptedType => {
                // Check for wildcard MIME types (e.g., "image/*")
                if (acceptedType.endsWith('/*')) {
                    const category = acceptedType.split('/')[0];
                    return fileType.startsWith(`${category}/`);
                }
                // Check for exact MIME type match
                else if (acceptedType.includes('/')) {
                    return fileType === acceptedType;
                }
                // Check for file extension match (e.g., ".pdf")
                else {
                    return acceptedType === fileExtension;
                }
            });
        },
        [accept],
    );

    const handleFileSelect = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = event.target.files;
            if (!files) return;

            const newFiles: FileData[] = [];
            let errorFound = false;

            Array.from(files).forEach(file => {
                // Check if file type is accepted
                if (!isFileTypeAccepted(file)) {
                    onError?.(
                        `File "${file.name}" is not an accepted file type. Please upload ${accept} files only.`,
                    );
                    errorFound = true;
                    return; // Skip file
                }

                // Check if file already selected (by name and size)
                if (
                    selectedFiles.some(
                        existing =>
                            existing.name === file.name && existing.size === file.size,
                    )
                ) {
                    console.warn(`File "${file.name}" is already selected.`);
                    return; // Skip duplicate
                }

                // Check file size
                if (maxFileSizeMB && file.size > maxFileSizeMB * 1024 * 1024) {
                    onError?.(
                        `File "${file.name}" exceeds the ${maxFileSizeMB}MB size limit.`,
                    );
                    errorFound = true;
                    return; // Skip file
                }

                // Check max file count
                if (maxFiles && selectedFiles.length + newFiles.length >= maxFiles) {
                    if (!errorFound) {
                        // Show only once per selection batch
                        onError?.(`You can only select up to ${maxFiles} files.`);
                        errorFound = true;
                    }
                    return; // Stop adding more files
                }

                // Create blob from file
                const blob = new Blob([file], { type: file.type });

                const fileData: FileData = {
                    file,
                    blob,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    uniqueId: generateUniqueId(), // Generate unique ID
                };

                // Create preview URL for images and PDFs
                if (file.type.startsWith('image/') || file.type === 'application/pdf') {
                    fileData.previewUrl = URL.createObjectURL(blob);
                }

                newFiles.push(fileData);
            });

            if (newFiles.length > 0) {
                setSelectedFiles(prev => [...prev, ...newFiles]);
            }

            // Reset file input value to allow selecting the same file again after removal
            if (event.target) {
                event.target.value = '';
            }
        },
        [
            selectedFiles,
            setSelectedFiles,
            maxFiles,
            maxFileSizeMB,
            onError,
            isFileTypeAccepted,
        ],
    );

    const handleRemoveFile = useCallback(
        (indexToRemove: number) => {
            // Call the custom handler if provided
            if (onRemoveFile) {
                onRemoveFile(indexToRemove);
                return;
            }

            // Original remove logic as fallback
            setSelectedFiles(prev => {
                const updatedFiles = [...prev];
                const fileToRemove = updatedFiles[indexToRemove];

                if (fileToRemove?.previewUrl && !fileToRemove.url) {
                    URL.revokeObjectURL(fileToRemove.previewUrl);
                }

                updatedFiles.splice(indexToRemove, 1);
                return updatedFiles;
            });
        },
        [onRemoveFile, setSelectedFiles],
    );

    const triggerFileInput = () => {
        fileInputRef.current?.click();
    };

    const handleActionClick = () => {
        if (onActionButtonClick) {
            // Convert all files to Blobs - either use existing blob or create one from URL
            const blobPromises = selectedFiles.map(async fileData => {
                // If we already have a blob, use it
                if (fileData.blob) {
                    return fileData.blob;
                }
                // If we have a file, convert to blob
                else if (fileData.file) {
                    return new Blob([fileData.file], { type: fileData.type });
                }
                // If we have a URL, fetch and convert to blob
                else if (fileData.url) {
                    try {
                        const response = await fetch(fileData.url);
                        return await response.blob();
                    } catch (error) {
                        console.error(
                            `Error fetching blob from URL ${fileData.url}:`,
                            error,
                        );
                        // Return a minimal empty blob as fallback
                        return new Blob([], { type: fileData.type });
                    }
                }
                // Fallback empty blob
                return new Blob([], { type: 'application/octet-stream' });
            });

            // Resolve all blob promises and call the action handler
            Promise.all(blobPromises)
                .then(blobs => {
                    onActionButtonClick(blobs);
                })
                .catch(error => {
                    console.error('Error processing blobs:', error);
                    onError?.('Error processing files. Please try again.');
                });
        }
    };

    const renderFilePreview = (fileData: FileData) => {
        if (fileData.previewUrl && fileData.type.startsWith('image/')) {
            // For images, show the image preview
            return <ImagePreview src={fileData.previewUrl} alt={fileData.name} />;
        } else if (fileData.type === 'application/pdf') {
            // For PDFs, show a PDF icon
            return (
                <IconPreview>
                    <PdfFileIcon />
                </IconPreview>
            );
        } else if (
            fileData.type.includes('word') ||
            fileData.type.includes('doc')
        ) {
            // For Word documents, show a Word icon
            return (
                <IconPreview>
                    <DocFileIcon />
                </IconPreview>
            );
        } else {
            // For other file types, show a generic file icon
            return (
                <IconPreview>
                    <GenericFileIcon />
                </IconPreview>
            );
        }
    };

    const canAddMore = !maxFiles || selectedFiles.length < maxFiles;

    // Format accept string for user-friendly display
    const getAcceptDescription = () => {
        if (!accept || accept === '*/*') return 'all files';

        // Parse accept string
        const acceptTypes = accept.split(',').map(type => {
            const trimmed = type.trim();

            // Handle MIME types
            if (trimmed.includes('/')) {
                const [category, subtype] = trimmed.split('/');
                if (subtype === '*') {
                    // Convert "image/*" to "images"
                    return `${category}s`;
                }
                // Convert specific MIME types to readable format
                return subtype === 'pdf'
                    ? 'PDFs'
                    : subtype === 'jpeg' || subtype === 'jpg'
                        ? 'JPEGs'
                        : subtype === 'png'
                            ? 'PNGs'
                            : subtype;
            }

            // Handle file extensions
            if (trimmed.startsWith('.')) {
                return trimmed.substring(1).toUpperCase();
            }

            return trimmed;
        });

        // Join with commas and "or" for the last item
        if (acceptTypes.length === 1) return acceptTypes[0];
        if (acceptTypes.length === 2)
            return `${acceptTypes[0]} or ${acceptTypes[1]}`;

        const lastType = acceptTypes.pop();
        return `${acceptTypes.join(', ')}, or ${lastType}`;
    };

    return (
        <>
            <Label className="label">
                {label ?? ''}
                <span className="red-star">{showStar ? '*' : ''}</span>
            </Label>
            <Wrapper
                className={`${className || ''} ${isLoader ? 'loader-style' : ''}`}
                bgColor={bgColor}
                borderColor={borderColor}
            >
                {/* Hidden File Input */}
                <HiddenInput
                    type="file"
                    multiple // Allow multiple files
                    accept={accept}
                    ref={fileInputRef}
                    onChange={handleFileSelect}
                    disabled={isLoader || !canAddMore}
                />

                {/* List of Selected Files */}
                <FileListContainer>
                    {selectedFiles.map((fileData, index) => (
                        <FileItem key={fileData.uniqueId || `${fileData.name}-${index}`}>
                            <FilePreviewWrapper>
                                {renderFilePreview(fileData)}
                            </FilePreviewWrapper>
                            <FileInfo>
                                <FileName title={fileData.name}>{fileData.name}</FileName>
                                <FileSize>{(fileData.size / 1024).toFixed(1)} KB</FileSize>
                            </FileInfo>
                            <RemoveButton
                                onClick={() => !isLoader && handleRemoveFile(index)}
                                title="Remove file"
                                disabled={isLoader}
                            >
                                <RemoveIcon />
                            </RemoveButton>
                        </FileItem>
                    ))}

                    {/* Add File Trigger - Show only if allowed */}
                    {canAddMore && (
                        <AddFileTrigger
                            onClick={triggerFileInput}
                            title={isLoader ? 'Processing...' : 'Add a file'}
                        >
                            <AddIconWrapper>{addIcon}</AddIconWrapper>
                            <span>{addButtonLabel}</span>
                            {accept && accept !== '*/*' && (
                                <AcceptInfo>
                                    Accepted file types: {getAcceptDescription()}
                                </AcceptInfo>
                            )}
                        </AddFileTrigger>
                    )}
                </FileListContainer>

                {/* Optional Overall Action Button */}
                {actionButtonLabel && selectedFiles.length > 0 && (
                    <ActionContainer>
                        <AdminCustomButton
                            buttonType={actionButtonType}
                            svgIcon={actionButtonSvgIcon}
                            onClick={handleActionClick}
                            disabled={isLoader || selectedFiles.length === 0} // Disable if no files or loading
                        >
                            {actionButtonLabel} {isLoader ? '(Uploading...)' : ''}
                        </AdminCustomButton>
                    </ActionContainer>
                )}

                {/* Optional Loader Overlay - adjust styling as needed */}
                {isLoader && <LoaderOverlay>Loading...</LoaderOverlay>}
            </Wrapper>
        </>
    );
};

// --- Styled Components ---

const AcceptInfo = styled.div`
  font-size: 11px;
  color: #888;
  margin-top: 8px;
  text-align: center;
`;
const Label = styled.div`
  &.label {
    font-family: 'Inter';
    font-size: 14px;
    font-weight: 500;
    color: #a3a3a3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 5px;
    letter-spacing: 0.5px;
    line-height: 19.6px;
  }
  .red-star {
    color: red;
    font-weight: bold;
  }

  :has(input:disabled) {
    .red-star {
      display: none !important;
    }
  }
  //Responsive
  @media (min-width: 100px) and (max-width: 319px) {
    &.label {
      font-size: 10px !important;
    }
    .k-input-value-text {
      height: 30px;
      font-size: 11px !important;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    &.label {
      font-size: 11px !important;
    }
    .k-input-value-text {
      height: 30px;
      font-size: 12px !important;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    &.label {
      font-size: 12px;
    }
    .k-input-value-text {
      font-size: 13px !important;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    &.label {
      font-size: 13px;
    }
    .k-input-value-text {
      font-size: 14px !important;
    }
  }
`;
const HiddenInput = styled.input`
  display: none;
`;

const Wrapper = styled.div<{ bgColor?: string; borderColor?: string }>`
  background-color: ${props =>
        props.bgColor || '#f8f9fa'}; // Light gray default
  border: 1px dashed ${props => props.borderColor || '#ced4da'}; // Dashed border default
  border-radius: 8px;
  padding: 20px;
  font-family: 'Inter', sans-serif; // Assuming Inter font
  position: relative; // Needed for loader overlay

  &.loader-style {
    opacity: 0.7;
    pointer-events: none; // Disable interactions while loading
  }
`;

const FileListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(200px, 1fr)
  ); // Responsive grid
  gap: 15px;
  margin-bottom: 20px; // Space before action button
`;

const FileItem = styled.div`
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  align-items: center;
  position: relative; // For remove button positioning
  gap: 10px;
  overflow: hidden; // Hide overflowing file names
`;

const FilePreviewWrapper = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1f3f5;
  border-radius: 4px;
  overflow: hidden; // Clip image previews
`;

const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

const IconPreview = styled.div`
  color: #868e96; // Icon color
  svg {
    width: 24px;
    height: 24px;
  }
`;

const FileInfo = styled.div`
  flex-grow: 1;
  overflow: hidden; // Prevent long names from breaking layout
  min-width: 0; // Allow flex item to shrink properly
`;

const FileName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #343a40;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileSize = styled.div`
  font-size: 11px;
  color: #868e96;
`;

const RemoveButton = styled.button<{ disabled?: boolean }>`
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255, 255, 255, 0.7); // Semi-transparent background
  border: none;
  border-radius: 50%;
  padding: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc3545; // Red color for remove
  opacity: 0.6;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
    background: rgba(220, 53, 69, 0.1); // Light red background on hover
  }

  svg {
    width: 12px;
    height: 12px;
  }

  ${({ disabled }) =>
        disabled &&
        `
      cursor: not-allowed;
      opacity: 0.3;
       &:hover {
         opacity: 0.3;
         background: rgba(255, 255, 255, 0.7);
       }
   `}
`;

const AddFileTrigger = styled.div`
  border: 2px dashed #adb5bd;
  border-radius: 6px;
  padding: 10px;
  min-height: 62px; // Match FileItem height roughly
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  color: #495057;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  font-size: 13px;
  gap: 5px;

  &:hover {
    background-color: #e9ecef;
    border-color: #868e96;
  }
`;

const AddIconWrapper = styled.div`
  color: #0d6efd; // Blue color for add icon
  svg {
    width: 20px;
    height: 20px;
  }
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end; // Align button to the right
  margin-top: 15px; // Add some space above the button if FileListContainer didn't have margin-bottom
`;

const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333;
  border-radius: 8px; // Match wrapper border-radius
  z-index: 10;
`;
